import { static_img_url, LazyImage } from '../../base'
import { useNavigate } from 'react-router-dom'



function Slider() {

    const navigate = useNavigate()
    return (
        <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <div className='d-flex' style={{maxWidth : '1100px', height : '100%', width : '95%', margin : 'auto', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className='main d-none d-md-block'>
                            <div className='h3 scolor stylishFont'>Ahilya Handlooms,</div>
                            <div className='h5'>" Grace of Maheshwari, Elegance of Silk – HandCrafted by Artisans, Delivered with Care. "</div>
                            <button className='secondryButton ps-5 pe-5' onClick={()=>navigate(`/p/shop/all/category/all/products/`)}>Shop Now </button>
                        </div>
                        <div className='imgdiv img1'>
                            <LazyImage src={`${static_img_url}/slider/slide1.webp`} alt='slider 1' />
                        </div>
                        <div className='content d-block d-md-none position-absolute'>
                            <div className='h3 scolor stylishFont'>Ahilya Handlooms,</div>
                            <div className='h5'> Grace of Maheshwari, Elegance of Silk – HandCrafted by Artisans, Delivered with Care. </div>
                            <button className='secondryButton ps-5 pe-5' onClick={()=>navigate(`/p/shop/all/category/all/products/`)}>Shop Now </button>
                        </div>
                    </div>
                </div>
                <div className="carousel-item ">
                    <div className='d-flex' style={{maxWidth : '1100px', height : '100%', width : '97%', margin : 'auto', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className='main d-none d-sm-block order-2 ps-3'>
                            <div className='h3 scolor'>A Legacy Woven in Threads – </div>
                            <div className='h5'>" Maheshwari Weaves, Inspired by Ahilya Bai Holkar, Now at Your Fingertips. "</div>
                            <button className='secondryButton ps-5 pe-5' onClick={()=>navigate(`/p/shop/all/category/all/products/`)}>Start Shopping</button>
                        </div>
                        <div className='imgdiv order-1'>
                            <LazyImage src={`${static_img_url}/slider/slide2.webp`} alt='slider 2' />
                        </div>
                        <div className='content d-block d-sm-none position-absolute'>
                            <div className='h3 scolor'>A Legacy Woven in Threads –</div>
                            <div className='h5'>Maheshwari Weaves, Inspired by Ahilya Bai Holkar, Now at Your Fingertips. </div>
                            <button className='secondryButton ps-5 pe-5 d-none' onClick={()=>navigate(`/p/shop/all/category/all/products/`)}>Shop Now </button>
                        </div>
                    </div>
                </div>
                <div className="carousel-item">
                    <div className='d-flex' style={{maxWidth : '1100px', height : '100%', width : '97%', margin : 'auto', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className='main d-none d-sm-block ps-2'>
                            <div className='h3 scolor'>A Saree Beyond The Time  –</div>
                            <div className='h5'>" Weaving Stories, Celebrating Traditions, Draping Generations "</div>
                        </div>
                        <div className='imgdiv'>
                        <LazyImage src={`${static_img_url}/slider/slide3.webp`} alt = 'slider 3' />
                        </div>
                        <div className='content d-block d-sm-none position-absolute'>
                            <div className='h3 scolor'>A Saree Beyond The Time  –</div>
                            <div className='h5'>" Weaving Stories, Celebrating Traditions, Draping Generations "</div>
                            <button className='secondryButton ps-5 pe-5 d-none' onClick={()=>navigate(`/p/shop/all/category/all/products/`)}>Shop Now </button>
                        </div>
                    </div>
                </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>

    )
}

export default Slider